/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FavoriteHotelPurgeResponse
 */
export interface FavoriteHotelPurgeResponse {
    /**
     * 
     * @type {string}
     * @memberof FavoriteHotelPurgeResponse
     */
    userId: string;
    /**
     * 
     * @type {number}
     * @memberof FavoriteHotelPurgeResponse
     */
    deletedCount: number;
}

/**
 * Check if a given object implements the FavoriteHotelPurgeResponse interface.
 */
export function instanceOfFavoriteHotelPurgeResponse(value: object): value is FavoriteHotelPurgeResponse {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('deletedCount' in value) || value['deletedCount'] === undefined) return false;
    return true;
}

export function FavoriteHotelPurgeResponseFromJSON(json: any): FavoriteHotelPurgeResponse {
    return FavoriteHotelPurgeResponseFromJSONTyped(json, false);
}

export function FavoriteHotelPurgeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FavoriteHotelPurgeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['user_id'],
        'deletedCount': json['deleted_count'],
    };
}

export function FavoriteHotelPurgeResponseToJSON(json: any): FavoriteHotelPurgeResponse {
    return FavoriteHotelPurgeResponseToJSONTyped(json, false);
}

export function FavoriteHotelPurgeResponseToJSONTyped(value?: FavoriteHotelPurgeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_id': value['userId'],
        'deleted_count': value['deletedCount'],
    };
}

